import React from "react";
import { Button, Spinner } from "react-bootstrap";
import styled from "styled-components";
import { colors } from "utils";
import { CRITICAL_RED } from "./styles";

const State = styled.div`
  color: ${colors.milkGlass950};
  padding: 28px 16px;
  text-align: center;
`;

export const LoadingState = () => (
  <State>
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading…</span>
    </Spinner>
  </State>
);

export const EmptyState = ({ children }) => <State>{children}</State>;

const ErrorText = styled.p`
  color: ${CRITICAL_RED};
  margin: 0 0 12px;
`;

export const ErrorState = ({ onRetry }) => (
  <State>
    <ErrorText>Could not load teacher report metrics. Try again.</ErrorText>
    <Button size="sm" variant="outline-secondary" onClick={onRetry}>
      Try again
    </Button>
  </State>
);
